import type { ReactNode } from "react";
import { formatDetailDuration } from "../evalRunResultModel";
import { CompareValueBarChart } from "./CompareValueBarChart";
import { fitDurationDomain, measuredSeries } from "./evalCompareChartModel";
import type { EvalResultSeries } from "./evalCompareModel";

export function DurationCompareChart({ items }: { items: readonly EvalResultSeries[] }): ReactNode {
  // 끝나지 않은 run 은 소요 시간이 null 이다. 0 으로 그리면 "0초에 끝난 실행"으로 읽힌다.
  // 그러면 같은 run 을 "미상"으로 표시하는 상세 화면과 맞지 않는다.
  const measured = measuredSeries(items, (summary) => summary.durationSec);
  return (
    <CompareValueBarChart
      title="실행 소요 시간"
      items={measured}
      value={(item) => item.summary.durationSec ?? 0}
      format={(value) => formatDetailDuration(Math.round(value))}
      domain={fitDurationDomain}
      yAxisWidth={52}
    />
  );
}
